import Sidebar from "./SideBar.vue";
import SidebarLink from "./SidebarLink.vue";
import AdminSideBar from "@/components/SidebarPlugin/AdminSideBar";

const SidebarStore = {
  showSidebar: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
};

const SidebarPlugin = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          sidebarStore: SidebarStore,
        };
      },
    });

    Object.defineProperty(Vue.prototype, "$sidebar", {
      get() {
        return this.$root.sidebarStore;
      },
    });
    Vue.component("side-bar", Sidebar);
    Vue.component("admin-side-bar", AdminSideBar);
    Vue.component("sidebar-link", SidebarLink);
  },
};

export default SidebarPlugin;
